import * as React from "react";

export type ArrowDirection = "up" | "down" | "left" | "right";

export class Arrow extends React.Component<{
    direction?: ArrowDirection
}, {}> {
    baseClass: string
    constructor(props) {
        super(props);
        this.baseClass = "rj-racing-arrow";
    }
    render() {
        const holderClass: string = `${this.baseClass}__holder`;
        const fullClass: string = holderClass + (this.props.direction ?
            ` ${holderClass}--${this.props.direction}` :
            "");

        return (
            <span className={this.baseClass}>
                <span className={fullClass}></span>
            </span>
        );
    }
}